/* Marcos Jacob — chrome + AJAX cart + PDP. Globals used by inline onclick in sections. */
(function () {
  var FREE = 7500; // cents, $75 free-shipping threshold
  function money(c) { var n = c / 100; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }

  // ---- chrome ----
  window.closeMob = function () { var m = document.getElementById('mobmenu'); if (m) m.classList.remove('open'); };
  window.openCart = function () { document.getElementById('cartov').classList.add('open'); document.getElementById('cartdrawer').classList.add('open'); document.body.style.overflow = 'hidden'; };
  window.closeCart = function () { document.getElementById('cartov').classList.remove('open'); document.getElementById('cartdrawer').classList.remove('open'); document.body.style.overflow = ''; };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); var g = document.getElementById('guide'); if (g) g.classList.remove('open'); } });

  // ---- AJAX cart ----
  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (c) { c.textContent = cart.item_count; });
    var wrap = document.getElementById('cartItems'); if (!wrap) return;
    var foot = document.getElementById('cartFoot');
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="cart-empty">Your bag is empty.</div>';
      if (foot) foot.style.display = 'none';
    } else {
      if (foot) foot.style.display = '';
      wrap.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        return '<div class="citem" data-key="' + it.key + '">' +
          '<div class="cimg"><img src="' + img + '" alt=""></div>' +
          '<div class="cinfo"><div class="cname">' + it.product_title + '</div><div class="cvar">' + (it.variant_title || '') + '</div>' +
          '<div class="cqty"><button onclick="mjQty(\'' + it.key + '\',-1)">&minus;</button><span>' + it.quantity + '</span><button onclick="mjQty(\'' + it.key + '\',1)">+</button></div></div>' +
          '<div class="cright"><div class="cprice">' + money(it.final_line_price) + '</div><button class="crem" onclick="mjQty(\'' + it.key + '\',0)">Remove</button></div></div>';
      }).join('');
    }
    var sub = document.getElementById('csub'); if (sub) sub.textContent = money(cart.total_price);
    var bar = document.querySelector('.cart-ship .bar i'), msg = document.querySelector('.cart-ship p');
    if (bar && msg) {
      if (cart.total_price >= FREE) { bar.style.width = '100%'; msg.textContent = 'Free shipping unlocked ✓'; }
      else { bar.style.width = Math.min(100, cart.total_price / FREE * 100) + '%'; msg.textContent = 'Add ' + money(FREE - cart.total_price) + ' for free U.S. shipping'; }
    }
  }
  function refresh(open) { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); if (open) openCart(); }); }
  window.mjQty = function (key, delta) {
    var line = document.querySelector('.citem[data-key="' + key + '"]');
    var span = line ? line.querySelector('.cqty span') : null;
    var qty = delta === 0 ? 0 : Math.max(0, (span ? parseInt(span.textContent) : 1) + delta);
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); });
  };
  window.mjAdd = function (variantId, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () { refresh(true); });
  };
  refresh(false);

  // ---- collection colour filter ----
  window.filterC = function (btn, c) {
    document.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('on'); });
    btn.classList.add('on');
    document.querySelectorAll('.grid5 .card').forEach(function (card) {
      var img = card.querySelector('.ph img');
      var src = c === 'all' ? card.dataset.lead : card.dataset[c];
      if (img && src) img.src = src;
    });
  };
  (function () { var m = location.search.match(/[?&]c=(cloud|oat|ink)/); if (m) { var b = document.querySelector('.pill[data-c="' + m[1] + '"]'); if (b) filterC(b, m[1]); } })();

  // ---- PDP (only on product pages) ----
  function initPDP() {
    var root = document.getElementById('mjPdp'); if (!root) return;
    var data = JSON.parse(document.getElementById('mjVariants').textContent);
    var stage = document.getElementById('stagewin');
    function setActive(i) {
      var n = document.getElementById('gnum'); if (n && stage) n.textContent = (i + 1) + ' / ' + stage.children.length;
      document.querySelectorAll('.gcount i').forEach(function (d, j) { d.classList.toggle('on', j === i); });
      document.querySelectorAll('.thumb').forEach(function (t, j) { t.classList.toggle('active', j === i); });
    }
    window.mjGo = function (i) { if (stage) stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' }); setActive(i); };
    if (stage) stage.addEventListener('scroll', function () { setActive(Math.round(stage.scrollLeft / stage.clientWidth)); });

    var state = { color: root.dataset.color, size: root.dataset.size };
    function syncVariant() {
      var v = data.find(function (x) { return x.color === state.color && x.size === state.size; });
      var btn = document.getElementById('mjAtc'), price = document.getElementById('mjPrice');
      if (v && v.available) { root.dataset.variant = v.id; btn.disabled = false; btn.textContent = 'Add to cart'; }
      else { btn.disabled = true; btn.textContent = v ? 'Sold out' : 'Unavailable'; }
      if (v && price) price.textContent = v.price;
    }
    window.mjPick = function (el, color) {
      state.color = color; document.getElementById('cname').textContent = color;
      document.querySelectorAll('.sw').forEach(function (s) { s.classList.remove('active'); }); el.classList.add('active');
      // swap gallery hero to this colour's flat (slide 0 image carries data-color sources)
      var hero = document.querySelector('.slide[data-role="flat"] img'), thumb = document.querySelector('.thumb[data-role="flat"] img');
      var src = root.querySelector('[data-flat="' + color.toLowerCase() + '"]');
      if (hero && src) hero.src = src.getAttribute('data-src');
      if (thumb && src) thumb.src = src.getAttribute('data-src');
      mjGo(0); syncVariant();
    };
    window.mjSize = function (el, size) { state.size = size; document.querySelectorAll('.size').forEach(function (s) { s.classList.remove('active'); }); el.classList.add('active'); syncVariant(); };
    window.mjAddCurrent = function () { if (root.dataset.variant) mjAdd(root.dataset.variant, 1); };
    window.openGuide = function (e) { if (e) e.preventDefault(); document.getElementById('guide').classList.add('open'); };
    window.closeGuide = function () { document.getElementById('guide').classList.remove('open'); };
    setActive(0); syncVariant();
    // adaptive title fit — desktop fits to one line; mobile wraps at a readable size
    var h = document.querySelector('.info h1');
    if (h) {
      if (window.innerWidth >= 760) {
        var avail = h.parentElement.clientWidth, s = 42; h.style.whiteSpace = 'nowrap'; h.style.display = 'inline-block'; h.style.fontSize = s + 'px'; var g = 0;
        while (h.offsetWidth > avail - 8 && s > 22 && g < 90) { s -= 0.5; h.style.fontSize = s + 'px'; g++; }
      } else {
        h.style.whiteSpace = 'normal'; h.style.display = 'block'; h.style.fontSize = '30px';
      }
    }
  }
  if (document.readyState !== 'loading') initPDP(); else document.addEventListener('DOMContentLoaded', initPDP);

  // ---- load + scroll reveal ----
  function initReveal() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;
    var reveal = function (el) { el.classList.add('mj-in'); };
    if (!('IntersectionObserver' in window)) { sections.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
    sections.forEach(function (s) { io.observe(s); });
    // safety net: nothing stays hidden if the observer never fires
    setTimeout(function () { sections.forEach(reveal); }, 2600);
  }

  // ---- accordion collapse / expand (height animated; box-sizing:border-box keeps 0 clean) ----
  function initAccordions() {
    document.querySelectorAll('details').forEach(function (d) {
      var sm = d.querySelector('summary'), body = d.querySelector('.body');
      if (!sm || !body) return;
      sm.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.dataset.anim) return;
        d.dataset.anim = '1';
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          body.offsetHeight; // force reflow
          body.style.height = '0px';
          setTimeout(function () { d.open = false; body.style.height = ''; delete d.dataset.anim; }, 320);
        } else {
          d.open = true;
          var target = body.scrollHeight;
          body.style.height = '0px';
          body.offsetHeight;
          body.style.height = target + 'px';
          setTimeout(function () { body.style.height = ''; delete d.dataset.anim; }, 320);
        }
      });
    });
  }

  // ---- FAQ page: smooth-scroll + scrollspy on the left category nav ----
  function initFaqNav() {
    var nav = document.querySelector('.faqnav'); if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('a'));
    var groups = links.map(function (a) { return document.querySelector(a.getAttribute('href')); }).filter(Boolean);
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', a.getAttribute('href')); }
      });
    });
    var setActive = function (id) { links.forEach(function (a) { a.classList.toggle('active', a.getAttribute('href') === '#' + id); }); };
    if (!('IntersectionObserver' in window)) { if (links[0]) links[0].classList.add('active'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
    }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
    groups.forEach(function (g) { io.observe(g); });
    setActive(groups[0] ? groups[0].id : '');
  }

  function initMotion() { initReveal(); initAccordions(); initFaqNav(); }
  if (document.readyState !== 'loading') initMotion(); else document.addEventListener('DOMContentLoaded', initMotion);
})();
